import { Routes, Route, Navigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import UserSidebar from '../components/UserSidebar';
import GrafikLaporan from '../components/GrafikLaporan';
import FormLaporan from '../components/FormLaporan';
import RiwayatLaporan from '../components/RiwayatLaporan';
import ChatbotSIPUMA from '../components/ChatbotSIPUMA'; 

import './UserDashboard.css';

const UserDashboardPage = () => {
    return (
        <div className="d-flex">
            <UserSidebar />
            <div className="flex-grow-1 p-4 user-dashboard">
                <div className="mb-4 welcome-header">
                    <h2 className="welcome-title">
                        <FaUserCircle className="welcome-icon" />
                        Halo Pelapor SIPUMA
                    </h2>
                    <p>Layanan dashboard pelaporan anonim. Hak privasi dan rahasia data Anda dijamin penuh oleh sistem tanpa kewajiban pendaftaran akun.</p>
                </div>

                <div className="content-container">
                    <Routes>
                        <Route path="/" element={<Navigate to="buat-laporan" replace />} />
                        <Route path="grafik" element={<GrafikLaporan />} />
                        <Route path="buat-laporan" element={<FormLaporan />} />
                        <Route path="riwayat" element={<RiwayatLaporan />} />
                        <Route path="tanya-sipuma" element={<ChatbotSIPUMA />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default UserDashboardPage;